import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import TypingBox from '../components/TypingBox'

 const Homepage = () => {
  return (
    <div>
        <Header />
        <TypingBox />
        <Footer />
    </div>
  )
}
export default Homepage